<script setup lang="ts">
import type { Praeparat } from '@/types/otc/praeparat'

import { toRef } from 'vue'
import {OrderService} from "@/api/order.service";
import {useSharedProductData} from "@/vue_components/praeparate/composables/useSharedProductData";
import {useDictionaryLabels} from "@/vue_components/praeparate/composables/useDictonaryLabels";

interface Props {
  praeparat: Praeparat
  dictionary: Record<string, string>
}

const props = defineProps<Props>()

const praeparatRef = toRef(props, 'praeparat')
const dictionaryRef = toRef(props, 'dictionary')

const { artikelList } = useSharedProductData(praeparatRef)
const { labels } = useDictionaryLabels(dictionaryRef)

const skus = OrderService.extractSkusFromArtikel(artikelList.value)

</script>

<template>
  <div v-if="artikelList.length" class="cta-order-wrapper">
    <p class="btn-inline order">
      <!--<a href="#" class="btn" :data-sku="`${skus}`">
       {{ labels.jetztBestellen }}
      </a>-->
    </p>
  </div>
</template>

<style scoped>
</style>